import { Table } from "@/features/Table";
import { type FileDelivery, file_deliveries_columns } from "./columns";
import { type FilterFileDeliverySchema, FilterFileDelivery } from "./filter";
import { useLocation } from "react-router";

const client = "instit-quantilia";
const table_name = "file_deliveries";

export const FileDeliveriesTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<FileDelivery, FilterFileDeliverySchema>
      label="File Deliveries"
      client={client}
      table_name={table_name}
      columns={file_deliveries_columns}
      filter={<FilterFileDelivery />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
